import { getItemMaker } from "./tools";

const i = getItemMaker("monster drops");
export const monsterDrops = [
  i("Spore Cap", "Grasslands1"),
  i("Frog Leg", "Grasslands2"),
  i("Bean Slices", "Grasslands3"),
  i("Red Spore Cap", "Grasslands4"),
  i("Slime Sludge", "Jungle1"),
  i("Snake Skin", "Jungle2"),
  i("Carrot Cube", "Jungle3"),
  i("Glublin Ear", "Forest1"),
  i("Plank", "Forest2"),
  i("Bullfrog Horn", "Forest3"),
  i("Corn Kernels", "Sewers1"),
  i("Golden Plop", "Sewers1b"),
  i("Rats Tail", "Sewers2"),
  i("Bonemeal", "Sewers3"),
  i("Stick", "TreeInterior1"),
  i("Woodular Circle", "TreeInterior1b"),
  i("Acorn", "TreeInterior2"),
  i("Pocket Sand", "DesertA1"),
  i("Glass Shard", "DesertA1b"),
  i("Megalodon Tooth", "DesertA2"),
  i("Crabby Cakey", "DesertA3"),
  i("Nuget Cake", "DesertA3b"),
  i("Coconotnotto", "DesertB1"),
  i("Furled Flag", "DesertB2"),
  i("Pincer Arm", "DesertB3"),
  i("Potato Remains", "DesertB4"),
  i("High Steaks", "DesertC1"),
  i("Wakka Cherry", "DesertC2"),
  i("Ghost", "DesertC2b"),
  i("Singlecle", "DesertC3"),
  i("Shrapshell", "DesertC4"),
  i("Floof Ploof", "SnowA1"),
  i("Melty Cube", "SnowA2"),
  i("Yellow Snowflake", "SnowA2a"),
  i("Moustache Comb", "SnowA3"),
  i("Ram Wool", "SnowA4"),
  i("Sticky Stick", "SnowB1"),
  i("Mamooth Tusk", "SnowB2"),
  i("Ice Age 3", "SnowB2a"),
  i("Snow Ball", "SnowB5"),
  i("Pen", "SnowB3"),
  i("Cracked Glass", "SnowB4"),
  i("Sippy Straw", "SnowC1"),
  i("Cryosnake Skin", "SnowC2"),
  i("Audio Cord", "SnowC3"),
  i("Contact Lense", "SnowC4"),
  i("Black Lense", "SnowC4a"),
  i("Blood Bone", "SnowC5"),
  i("Purple Mush Cap", "GalaxyA1"),
  i("TV Remote", "GalaxyA2"),
  i("Lost Batteries", "GalaxyA2b"),
  i("Half Eaten Donut", "GalaxyA3"),
  i("Genie Lamp", "GalaxyA4"),
  i("Bottle Cap", "GalaxyB1"),
  i("Wurm Tail", "GalaxyB2"),
  i("Tongue Bone", "GalaxyB3"),
  i("Crumpled Wrapper", "GalaxyB4"),
  i("Smol Worm", "GalaxyB5"),
  i("Empty Oyster Shell", "GalaxyC1"),
  i("Pearler Shell", "GalaxyC1b"),
  i("Wriggly Ball", "GalaxyC2"),
  i("Gel Chunk", "GalaxyC3"),
  i("Condensed Zap", "GalaxyC4"),
  i("Suggma Ashes", "LavaA1"),
  i("Royal Suggma Urn", "LavaA1b"),
  i("Plated Crumbs", "LavaA2"),
  i("Sundried Glass", "LavaA3"),
  i("Cheesy Crumbs", "LavaA4"),
  i("Stilt Pole", "LavaA5"),
  i("Hampter", "LavaA5b"),
  i("Meteorite", "LavaB1"),
  i("Shattered Skull", "LavaB2"),
  i("Orange Slice", "LavaB3"),
  i("OJ Juice", "LavaB3b"),
  i("Molten Lamp", "LavaB4"),
  i("Spitfire", "LavaB5"),
  i("Hard Hat", "LavaB6"),
  i("Wormie Slices", "LavaC1"),
  i("Mongo Worm Slices", "LavaC2"),
  i("Leafy Droplet", "SpiA1"),
  i("Rice Cake", "SpiA2"),
  i("Stacked Rice Cake", "SpiA2b"),
  i("Bamboo", "SpiA3"),
  i("Leafy Horn", "SpiA4"),
  i("Wooden Aortic Mass", "SpiA5"),
  i("Leafy Branch", "SpiB1"),
  i("Light Lantern", "SpiB2"),
  i("Dark Lantern", "SpiB2b"),
  i("Troll Flower", "SpiB3"),
  i("Chopped Leek"),
  i("Shattered Ceramic"),
  i("Eviscerated Chunk"),
  i("Royal Yolk"),
  i("Royal Fabric"),
  i("Royal Headpiece"),
  i("Baba Yaga Baby Eggs", "BabaYagaETC"),
  i("Minuteglass", "Hgg"),
  i("Amarok Slab", "Quest17"),
  i("Chaotic Amarok Slab", "Quest29"),
  i("Ripped Tunic", "EfauntDrop1"),
  i("Ribbed Tunic", "EfauntDrop2"),
  i("Chizoar Spike", "Chiz0"),
  i("Chizoar Stalagmite", "Chiz1"),
  i("Troll Scales", "TrollPart"),
  i("Kruk Tooth", "KrukPart"),
  i("Kruk Cavity Tooth", "KrukPart2"),
];
